import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { PostHogBooleanFlag, PostHogFlagsService } from '@rma/generic/util/posthog';
import { PlatformService } from '@rma/public/generic/util/environment';

/**
 * The canary has no surface and no product meaning: reading it is the whole point. The read proves
 * the server evaluated a real value, that `TransferState` carried it, and that the browser logs one
 * exposure against it. Nothing branches on the answer, so there is no arm to render.
 */
export function provideRmaPostHogCanary(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const platform = inject(PlatformService);
      const flags = inject(PostHogFlagsService);

      if (!platform.isTrackable) {
        return;
      }

      flags.read(PostHogBooleanFlag.PublicSsrFlagCanary, false);
    }),
  ]);
}
